import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Space,
  Button,
  Checkbox,
} from '@lockerpm/design';

import {
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import {
  convertDateTime,
} from '../../../../../utils/common'

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const isReadOnly = useSelector((state) => state.project.isReadOnly)

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    selectedRowKeys = [],
    selectionChange = () => {},
    onUpdate = () => {},
    onDelete = () => {}
  } = props;

  const boxData = useMemo(() => {
    return data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))
  }, [data])

  return (
    <Collapse
      className={className}
      bordered={true}
      expandIconPosition="end"
      size="small"
      collapsible='icon'
      loading={loading}
    >
      {
        boxData.map((record) => <Collapse.Panel
          key={record.id}
          header={<div
            className="flex align-items justify-between"
          >
            <div className="flex align-items">
              {
                !isReadOnly && <Checkbox
                  className="mr-2"
                  checked={selectedRowKeys.includes(record.id)}
                  onChange={(e) => selectionChange(null, record.id, e.target.checked)}
                />
              }
              <TextCopy
                value={record.environment.name}
              />
            </div>
            {
              !isReadOnly && <Space size={[8, 8]}>
                <Button
                  icon={<EditOutlined />}
                  type={'link'}
                  size="small"
                  onClick={() => onUpdate(record)}
                ></Button>
                <Button
                  icon={<DeleteOutlined />}
                  type={'link'}
                  size="small"
                  danger
                  onClick={() => onDelete(record)}
                ></Button>
              </Space>
            }
          </div>}
        >
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('environment.external_url')}:</p>
            <TextCopy
              value={record.environment.externalUrl}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.created_time')}:</p>
            <TextCopy
              value={convertDateTime(record.creationDate)}
            />
          </div>
          <div className="flex items-center">
            <p className="font-semibold mr-2">{t('common.updated_time')}:</p>
            <TextCopy
              value={convertDateTime(record.updatedDate)}
            />
          </div>
        </Collapse.Panel>)
      }
    </Collapse>
  );
}

export default BoxData;
